import { Entity, Id, ValueObject } from '@/common//base-types'
import Currency from '@/common/currency'
import Denomination from '@/common/denomination'
import { Behaviour } from '@/common/behaviours'

export enum RefSource {
  SetStatus = 'set_status',
  Combine = 'combine',
  Divide = 'divide',
  Transfer = 'transfer',
  RelationshipUpdated = 'relationship_updated',
  ParentCreate = 'parent_create',
  LinkReceive = 'link_receive',
  TokenRegister = 'token_register',
  TokenDispose = 'token_dispose'
}

export enum ContactType {
  Parent = 'parent',
  Child = 'child',
  Friend = 'friend',
  Payment = 'payment'
}

export enum ContactSource {
  Onboarding = 'onboarding',
  Relations = 'relations',
  Payment = 'payment'
}

export enum TokenType {
  Coin = 'coin',
  Ting = 'ting',
  Item = 'item',
  Ephemeral = 'ephe'
}

export enum ContentType {
  Emoji = 'emoji',
  WalletFace = 'walletface',
  Tool = 'tool',
  News = 'news',
  Message = 'message'
}

export enum ToolVariant {
  Savegoal = 'savegoal',
  Calculator = 'calculator',
  Message = 'message'
}

export enum AssetChangeType {
  Created = 'created',
  Deleted = 'deleted'
}
export interface ITokenDetail {
  color: string
  asset: Asset | undefined
}

export enum Hints {
  IdentityUnknown = 'identity_unknown'
}

export enum PaymentStatus {
  Pending = 'pending',
  Cancelled = 'cancelled',
  Done = 'done'
}

export enum Medium {
  Link = 'link'
}

export interface WalletContact extends ValueObject {
  walletId: Id
  ownerId: Id
  online: boolean
  availableForTransfer: boolean
  name: string
  source: ContactSource
  type: ContactType
  amountCentsTotal: number
  amountCentsPayed: number
  amountCentsDue: number
  status: PaymentStatus
  deleted: boolean
  hidden?: boolean
  uxPub: any
  lastOnline?: number
  updateInfo: UpdateInfo
  timeStamp: number
}

export interface PaymentRequestCreate extends ValueObject {
  referenceId: string
  message: string
  currency: Currency
  amountCents: number
}

export interface PaymentRequestCancel extends ValueObject {
  paymentRequestId: string
}

export interface PaymentRequest extends ValueObject {
  id: string
  paymentType: string
  referenceId: string
  message: string
  currency: Currency
  status: PaymentStatus
  amountCentsTotal: number
  amountCentsPayed: number
  amountCentsDue: number
  transactionId: string
  linkShortId: string
}

export interface Asset extends Entity {
  c: Currency | ContentType
  t: TokenType
  ux: any
  sn: string
  d?: Denomination
  va?: string
  isFake?: boolean
}

export interface Change extends ValueObject {
  assets: Id[]
  change: AssetChangeType
  tx: any
}

export interface WalletUpdate extends ValueObject {
  assets: Asset[]
  hints: string[]
  firstName: string
  lastName: string
  ux: any
  uxPub: any
  updateInfo: UpdateInfo
  timeStamp: number
}

export interface TokenChanges extends ValueObject {
  created: Asset[]
  deleted: Id[]
  updated: Asset[]
  updateInfo: UpdateInfo
}

export interface WalletPoke extends ValueObject {
  type: string
  senderId: string
  data: any
}

export interface WalletContainerCreate extends ValueObject {
  medium: Medium
  tokenIds: Id[]
  message?: string
  behaviours?: Behaviour[]
}

export interface WalletContainer extends ValueObject {
  linkShortId: string
  linkUrl: string
  linkQrUrl: string
  updateInfo: UpdateInfo
}

export interface UpdateInfo {
  refId: string
  refSource: string
}

export interface Vault extends Entity {
  name: string
  image: string
  transactions: []
}

export interface ITransferActionData {
  toVault: string
  id: Id
}

export interface IAssetCreate {
  series: string
  d: Denomination
}
export interface ITokenRegister {
  tokenType: TokenType
  assetType: ContentType
  variant: string
  ux?: any
  uxPub?: any
  uxPriv?: any
}

export interface IMoveActionData {
  fromRoom: string
  toRoom: string
  slot: string
  asset: Asset
}

export enum MenuItemType {
  None = 'none',
  Contacts = 'contacts',
  Profile = 'profile',
  Theme = 'theme',
  TopUp = 'topup',
  Scanner = 'scanner'
}

export enum ConnectionStatus {
  Available,
  Unavailable
}

export enum FeatureFlagState {
  On = 'on',
  Off = 'off',
  Default = 'default'
}
